export const PRESET_SIZES = {
	lg: { w: 1200, h: 676 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = ['kit_test'] as const;
